// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vUmw","requiredAsterisk":"Info_requiredAsterisk__3cz6G"};